var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPlayGift),expression:"isPlayGift"}],ref:"canvas",staticClass:"svgaContainer",attrs:{"id":"svgaCanvas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }